// See their "level" and above
export const authRoles = {
  siteAdministrator: ["SiteAdministrator"],
  superUser: ["SiteAdministrator", "SuperUser"],
  clinician: ["SiteAdministrator", "SuperUser", "Clinician"],
  patient: [],
};
